"use client";

import { Link } from "@/i18n/navigation";
import Button from "@/components/ui/Button/Button";

export default function AcceleratorCard(props) {
    if (props.name === "rocket") {
        return (
            <div>
                <Link href="/accelerators/rocket">
                    <div className="border border-gray-100 hover:border-primary dark:hover:border-primary duration-150 bg-gray-100 dark:bg-bgDark-840 h-full flex flex-col dark:border-borderDark rounded-xl lg:p-8 p-5 text-black dark:text-white">
                        <div className="flex justify-between items-center">
                            <h2 className="font-bold lg:text-2xl text-xl">
                                Formation développeur web et web mobile
                                <span className="text-primary">・Rocket</span>
                            </h2>
                        </div>
                        <div className="mt-1 flex-1">
                            Vivez une toute nouvelle aventure grâce au métier de
                            développeur web et apprenez à construire des sites
                            web sur tous les appareils.
                        </div>
                        <div className="mt-4 flex justify-end">
                            <Button>En savoir plus</Button>
                        </div>
                    </div>
                </Link>
            </div>
        );
    } else if (props.name === "belleannee") {
        return (
            <div>
                <Link href="https://belleannee.believemy.com">
                    <div className="border border-gray-100 hover:border-primary dark:hover:border-primary duration-150 bg-gray-100 dark:bg-bgDark-840 h-full flex flex-col dark:border-borderDark rounded-xl lg:p-8 p-5 text-black dark:text-white">
                        <div className="flex justify-between items-center">
                            <h2 className="font-bold lg:text-2xl text-xl">
                                Formation réussir son année
                                <span className="text-primary">
                                    ・Belle Année
                                </span>
                            </h2>
                        </div>
                        <div className="mt-1 flex-1">
                            Apprendre les recettes pour donner vie à ses
                            projets, ses rêves et réussir son année.
                        </div>
                        <div className="mt-4 flex justify-end">
                            <Button>En savoir plus</Button>
                        </div>
                    </div>
                </Link>
            </div>
        );
    } else {
        return <div></div>;
    }
}
